import { render, staticRenderFns } from "./ShowcaseFaq.vue?vue&type=template&id=3b6cd99f&scoped=true&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ShowcaseFaq.vue?vue&type=script&lang=js&"
export * from "./ShowcaseFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cd99f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6cd99f')) {
      api.createRecord('3b6cd99f', component.options)
    } else {
      api.reload('3b6cd99f', component.options)
    }
    module.hot.accept("./ShowcaseFaq.vue?vue&type=template&id=3b6cd99f&scoped=true&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('3b6cd99f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/ShowcaseFaq.vue"
export default component.exports